export default {
    methods: {
        showFullDescription() {
            this.notify({message: 'الرجاء تسجيل الدخول', show: true})
        },
    }
}